import type { WidgetMode } from '~/common/@types'

let mode: WidgetMode | undefined

export const setWidgetMode = (value?: WidgetMode) => {
  mode = value
}

export const getWidgetMode = () => {
  return mode
}
